export function formatRequestId(value) {
    if (value === null || value === undefined || value === '') {
        return 'Unknown';
    }

    const normalized = String(value).trim();
    if (!normalized) {
        return 'Unknown';
    }

    if (/^REQ\d+$/i.test(normalized)) {
        return normalized.toUpperCase();
    }

    if (/^\d+$/.test(normalized)) {
        return `REQ${normalized.padStart(5, '0')}`;
    }

    return normalized;
};

export function parseRequestId(value) {
    if (!value) {
        return value;
    }

    const match = String(value).trim().match(/^REQ(\d+)$/i);
    return match ? match[1] : value;
};
